<template>
    <div>
       
       
        <!-- Start Features Area -->
        <div class="features-area ptb-100 bg-F7F7FF">
            <div class="container">
                <div class="section-title">
                    <span class="sub-title text-uppercase  ">{{ data?.title||"APP" }}</span>
                    <h2>{{ data?.sub_title||"Most Probably Included Best Features Ever" }}</h2>
                </div>
                

                <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-6 col-sm-6 col-md-6" v-for="offers in data?.Keys" :key="offers?.id">
                        <div class="single-features-item">
                            <div class="icon">
                                <i class="ri-eye-line"></i>
                            </div>
                            <h3>{{ offers?.title || 'name'}}</h3>
                            <p>{{ offers?.description || 'title'}}</p>
                        </div>
                    </div>
                </div>  


            </div>
        </div>
        <!-- End Features Area -->

    </div>
</template>

<script>
export default {
    name: 'IndustriesOffers',
    
    props:{
     data:[],
    },
}
</script>